import ProgressCircle from '../../form/progress-circle'
import { Icon } from '../../../atoms'
import React from 'react'

interface PrefillProps {
  loading: boolean
}

const Prefill: React.FC<PrefillProps> = ({ loading }) => {
  return (
    <div className='SMEform__infoBox'>
      {loading ? <ProgressCircle height={24} /> : <Icon glyph='thumbs-up' size={24} />}
      <div>
        {loading
          ? "We're pre-filling your details to save time"
          : 'We’ve pre-filled your details to save you time. Just review and continue.'}
      </div>
    </div>
  )
}

export default Prefill
